export default __webpack_public_path__ + "static/media/sumo-code-example.cf274670.md";